import { getIssuePriority } from 'shared/constants/issues';
import {
  CaseIdColumn,
  EmergencyColumn,
  OrderTimeColumn,
  CompleteTimeColumn,
  WageColumn,
  ViewColumn,
  FlagColumn,
} from 'views/Wages/commonColumns';
import logger from 'utils/logger';

const log = logger.createLogger('PaidWage');

export const getKenshinTableData = (paidWageData, selectedDoctorId) => {
  const paidWage = paidWageData.filter(
    (item) => item.doctorId === selectedDoctorId
  );

  const tableData = paidWage.map((wage) => {
    const {
      id,
      createdAt,
      issueId,
      caseIdentifierId,
      casePriority,
      caseCreatedAt,
      originalWage,
      currentWage,
      starred,
    } = wage;

    return {
      caseId: caseIdentifierId,
      emergency: getIssuePriority(casePriority),
      orderTime: caseCreatedAt,
      completeTime: createdAt,
      wage: {
        originalWage: originalWage,
        currentWage: currentWage,
      },
      view: {
        wageId: id,
        issueId: issueId,
      },
      flag: starred,
    };
  });

  return tableData;
};

export const getKenshinTableColumns = (openKenshinIssue) => [
  CaseIdColumn(),
  EmergencyColumn(),
  OrderTimeColumn(),
  CompleteTimeColumn(),
  WageColumn(),
  ViewColumn(openKenshinIssue),
  FlagColumn(),
];
